import { render } from "./CountryProfileGlobalView.vue?vue&type=template&id=50207134"
import script from "./CountryProfileGlobalView.vue?vue&type=script&lang=js"
export * from "./CountryProfileGlobalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__